const isReport = (item: V3.Navigation.Item): item is V3.Navigation.Report =>
  item.type === 'Report';

const isDashboard = (
  item: V3.Navigation.Item,
): item is V3.Navigation.Dashboard => item.type === 'Dashboard';

const isScorecard = (
  item: V3.Navigation.Item,
): item is V3.Navigation.Scorecard => item.type === 'Scorecard';

const isEntityApp = (
  item: V3.Navigation.Item,
): item is V3.Navigation.EntityApp => item.type === 'Entity App';

const isReportsIndex = (
  item: V3.Navigation.Item,
): item is V3.Navigation.ReportsIndex => item.type === 'Reports Index';

const isDashboardsIndex = (
  item: V3.Navigation.Item,
): item is V3.Navigation.DashboardsIndex => item.type === 'Dashboards Index';

const isScorecardsIndex = (
  item: V3.Navigation.Item,
): item is V3.Navigation.ScorecardsIndex => item.type === 'Scorecards Index';

const isSignOffBoard = (
  item: V3.Navigation.Item,
): item is V3.Navigation.SignOffBoard => item.type === 'Sign Off Board';

const isBoard = (item: V3.Navigation.Item): item is V3.Navigation.Board =>
  item.type === 'Board';

const isBonusHome = (
  item: V3.Navigation.Item,
): item is V3.Navigation.BonusHome => item.type === 'Bonus Home';

const isBonusPicker = (
  item: V3.Navigation.Item,
): item is V3.Navigation.BonusPeriodPicker =>
  item.type === 'Bonus Period Picker';

const isBonusConfiguration = (
  item: V3.Navigation.Item,
): item is V3.Navigation.BonusConfiguration =>
  item.type === 'Bonus Configuration';

const isMappedEntityView = (
  item: V3.Navigation.Item,
): item is V3.Navigation.MappedEntityView => item.type === 'Mapped Entity View';

const isUsers = (item: V3.Navigation.Item): item is V3.Navigation.Users =>
  item.type === 'Users';

const isTargetsOverview = (
  item: V3.Navigation.Item,
): item is V3.Navigation.TargetsOverview => item.type === 'Targets Overview';

const isTargetManager = (
  item: V3.Navigation.Item,
): item is V3.Navigation.TargetsManager => item.type === 'Targets Manager';

const isGoalsIndex = (
  item: V3.Navigation.Item,
): item is V3.Navigation.GoalsIndex => item.type === 'Goals Index';

const isTasks = (item: V3.Navigation.Item): item is V3.Navigation.Tasks =>
  item.type === 'Tasks';

const isAllAssets = (
  item: V3.Navigation.Item,
): item is V3.Navigation.AllAssets => item.type === 'All Assets';

const isPaceExclusionWindow = (
  item: V3.Navigation.Item,
): item is V3.Navigation.PaceExclusionWindows =>
  item.type === 'Pace - Exclusion Windows';

const isReasonCodes = (
  item: V3.Navigation.Item,
): item is V3.Navigation.ReasonCodes => item.type === 'Reason Codes';

const isFileUpload = (
  item: V3.Navigation.Item,
): item is V3.Navigation.FileUpload => item.type === 'File Upload';

const isDriverSetupAndAppAccess = (
  item: V3.Navigation.Item,
): item is V3.Navigation.DriverSetupAndAppAccess =>
  item.type === 'Driver Setup & App Access';

const isBonusSimulator = (
  item: V3.Navigation.Item,
): item is V3.Navigation.BonusSimulator => item.type === 'Bonus Simulator';

const isBonusReasonCodes = (
  item: V3.Navigation.Item,
): item is V3.Navigation.BonusReasonCodes => item.type === 'Bonus Reason Codes';

const isApprovals = (
  item: V3.Navigation.Item,
): item is V3.Navigation.Approvals => item.type === 'Approvals';

const isLegacyBonusSummary = (
  item: V3.Navigation.Item,
): item is V3.Navigation.LegacyBonusSummary =>
  item.type === 'Legacy Bonus Summary';

const isLegacyBonusBoard = (
  item: V3.Navigation.Item,
): item is V3.Navigation.LegacyBonusBoard => item.type === 'Legacy Bonus Board';

const appNavItemTypeCheckers = {
  isReport,
  isDashboard,
  isScorecard,
  isEntityApp,
  isReportsIndex,
  isDashboardsIndex,
  isScorecardsIndex,
  isSignOffBoard,
  isBoard,
  isBonusHome,
  isBonusPicker,
  isBonusConfiguration,
  isMappedEntityView,
  isUsers,
  isTargetsOverview,
  isTargetManager,
  isGoalsIndex,
  isTasks,
  isAllAssets,
  isPaceExclusionWindow,
  isReasonCodes,
  isFileUpload,
  isDriverSetupAndAppAccess,
  isBonusSimulator,
  isBonusReasonCodes,
  isApprovals,
  isLegacyBonusSummary,
  isLegacyBonusBoard,
};

export default appNavItemTypeCheckers;
